/**
 *
 *
 * THIS FILE IS SHARED BETWEEN THE CLIENT AND SERVER.
 *
 * DO NOT ADD ANYTHING SERVER-SPECIFIC TO THIS FILE.
 *
 *
 *
 */
export * from './monitoringGroups';

export const LABEL_STATUS = 'status';
export const LABEL_HOSTNAME = 'hostname';
export const LABEL_TRANSACTION = 'rum_transaction_name';
export const LABEL_APP_VERSION = 'app_version';
export const LABEL_CONFIG_BUCKET = 'config_bucket';
export const LABEL_RESPONSE_STATUS = 'response_status';
export const LABEL_DEPLOY_TIME = 'deploy_time';
export const LABEL_GIT_REVISION = 'git_revision';
export const LABEL_PROCESS_ID = 'pm2_process_id';
export const LABEL_STATUS_CODE = 'status_code';
export const LABEL_REQUEST_LOCALE = 'request_locale';
export const LABEL_FORWARDED_HOST = 'forwarded_host';
export const LABEL_FORWARDED_VALUE_LIVE = 'live';
export const LABEL_FORWARDED_VALUE_NOT_LIVE = `not-${LABEL_FORWARDED_VALUE_LIVE}`;

export const LABEL_VALUE_SUCCESS = 'success';
export const LABEL_VALUE_ERROR = 'error';

export const LABEL_VALUE_LOCALE_EN_US = 'en-US' as const;
export const LABEL_VALUE_LOCALE_NON_EN_US = 'non-en-US' as const;
export type LOCALE_VALUES = typeof LABEL_VALUE_LOCALE_EN_US | typeof LABEL_VALUE_LOCALE_NON_EN_US;

export const LABEL_LATENCY_THRESHOLD_MS = 'latency_threshold_ms' as const;
export const LABEL_APDEX_TYPE = 'apdex_type' as const;
export const APDEX_SATISFIED = 'satisfied' as const;
export const APDEX_TOLERATING = 'tolerating' as const;
export type APDEX_THRESHOLDS = typeof APDEX_SATISFIED | typeof APDEX_TOLERATING;
export const APDEX_TYPE = {
    SATISFIED: APDEX_SATISFIED,
    TOLERATING: APDEX_TOLERATING,
} as const;
export const isApdexType = (v: string): v is typeof APDEX_TYPE[keyof typeof APDEX_TYPE] =>
    Object.values(APDEX_TYPE).includes(v as APDEX_THRESHOLDS);
